import { h, Component } from 'preact'
import padStart from 'lodash.padstart'
import { colors } from '../../constants'
import * as svgs from '../svgs'
import hoverable from '../hoverable'
import TooltipBubble from '../TooltipBubble'
import { Checkbox } from '../visual'

const positivityToColor = val =>
  val === 1 ? colors.green : val === -1 ? colors.red : colors.middleGrey

const Positivity = ({ val }) => (
  <div
    style={{
      backgroundColor: positivityToColor(val),
      display: 'inline-block',
      padding: '5px 25px 5px 15px',
      color: 'white',
      position: 'relative',
      height: 36,
    }}
  >
    STANOVISKO <svgs.PanacekWhite />:{' '}
    {val === 1 ? 'POZITIVNÍ' : val === -1 ? 'NEGATIVNÍ' : 'NEUTRÁLNÍ'}
    <div
      style={{
        display: 'inline-block',
        borderRight: `15px solid ${colors.grey}`,
        borderTop: '18px solid transparent',
        borderBottom: '18px solid transparent',
        width: '20px',
        height: '100%',
        position: 'absolute',
        right: 0,
        top: 0,
      }}
    />
  </div>
)

const Paragraph = ({ fullness = 1, color = colors.green } = {}) => (
  <div style={{ position: 'relative', height: 110 }}>
    <div
      style={{
        position: 'absolute',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    >
      <svgs.Paragraph portion={1 - fullness} />
      <svgs.Paragraph color={color} offset={1 - fullness} portion={fullness} />
    </div>
  </div>
)

const VoteLeftColumn = hoverable(
  ({ data, hover, onMouseEnter, onMouseLeave }) => (
    <div
      style={{
        height: '100%',
        position: 'relative',
        display: 'table',
      }}
    >
      <div
        style={{
          lineHeight: '1em',
          fontStyle: 'italic',
          textDecoration: 'underline',
          display: 'table-row',
          height: '33%',
        }}
      >
        {data.restName}
      </div>
      <div style={{ display: 'table-row', height: '33%' }}>
        <Paragraph
          fullness={data.weight}
          color={positivityToColor(data.positivity)}
        />
      </div>
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ display: 'table-row', height: '33%', paddingBottom: 10 }}
      >
        <div style={{ display: 'table-cell', verticalAlign: 'bottom' }}>
          {hover && (
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', left: '50%' }}>
                <TooltipBubble width={250} offset={0.22}>
                  VÁHA UKAZUJE JAKÝ VLIV MĚLO DANÉ HLASOVÁNÍ NA OSUD ZÁKONA
                </TooltipBubble>
              </div>
            </div>
          )}
          <div
            style={{
              fontSize: '1.5em',
              lineHeight: '1em',
              textAlign: 'center',
            }}
          >
            {data.weight.toFixed(2)}
          </div>
          <div style={{ textAlign: 'center', marginTop: -3 }}>váha</div>
        </div>
      </div>
    </div>
  ),
)

const VoteMiddleColumn = ({ data }) => (
  <div style={{ paddingRight: 40, paddingLeft: 15 }}>
    <div style={{ paddingLeft: 25 }}>
      <Positivity val={data.positivity} />
    </div>
    <div
      style={{
        fontSize: '1.4em',
        lineHeight: '1.2em',
        textTransform: 'uppercase',
        minHeight: 100,
        paddingTop: 20,
        paddingBottom: 40,
      }}
    >
      {data.description}
    </div>
    <div style={data.standpoint ? {} : { display: 'none' }}>
      {' '}
      {/* FIXME */}
      NAŠE STANOVISKO PODROBNĚ: <i>{data.standpoint}</i>
    </div>
  </div>
)

const voteToColor = data => {
  if (data.vote === '@') return 'gray'
  else if (data.positivity === 0) return 'gray'
  else if (data.vote === 'ANO') return data.positivity === 1 ? 'green' : 'red'
  else return data.positivity !== 1 ? 'green' : 'red'
}

const Result = ({ data, type, style = {} }) => (
  <a
    target="blank"
    href={
      type === 'MOP'
        ? `https://www.psp.cz/sqw/hlasy.sqw?g=${data.link}`
        : data.link
    }
    style={{
      color: colors.greyOnGrey,
      ...style,
    }}
  >
    {data.result.slice(0, 1).toUpperCase()}
    {data.result.slice(1)}: {data.date}
  </a>
)

const VoteThumb = ({ person, data, style }) => (
  <div
    style={{
      ...style,
      color: {
        gray: colors.greyOnGrey,
        green: colors.green,
        red: colors.red,
      }[voteToColor(data)],
      fontSize: '2em',
    }}
  >
    <div
      style={{
        display: 'table-cell',
        verticalAlign: 'middle',
        paddingBottom: 30,
      }}
    >
      <div
        style={{
          display: 'inline-block',
          paddingRight: voteToColor(data) === 'gray' ? 0 : 10,
        }}
      >
        {{
          ANO: 'pro',
          NE: 'proti',
          'zdržel se': person.gender === 'M' ? 'zdržel se' : 'zdržela se',
          '@': person.gender === 'M' ? 'nepřítomen' : 'nepřítomna',
        }[data.vote] || 'chyba'}
      </div>
      <div style={{ display: 'inline-block', transform: 'translateY(5px)' }}>
        {
          {
            gray: '',
            green: <svgs.ThumbsUp />,
            red: <svgs.ThumbsDown />,
          }[voteToColor(data)]
        }
      </div>
    </div>
  </div>
)

const VoteHead = ({ person, data, style }) => (
  <div style={style}>
    <span>{`${person.name.firstname} `}</span>
    <span>{`${person.name.surname} `}</span>
    <span>
      {(() => {
        if (data.vote === '@') return person.gender === 'M' ? 'byl:' : 'byla:'
        return person.gender === 'M' ? 'hlasoval:' : 'hlasovala:'
      })()}
    </span>
  </div>
)
const VoteRightColumn = ({ person, data }) => (
  <div
    style={{
      textAlign: 'center',
      height: '100%',
      display: 'table',
      width: '100%',
    }}
  >
    <VoteHead
      style={{
        marginTop: 15,
        marginBottom: 30,
        display: 'table-row',
        height: '33%',
      }}
      person={person}
      data={data}
    />

    <VoteThumb
      person={person}
      data={data}
      style={{
        display: 'table-row',
        height: '33%',
      }}
    />
    <div
      style={{
        display: 'table-row',
        height: '33%',
      }}
    >
      <Result
        data={data}
        type={person.type}
        style={{
          verticalAlign: 'bottom',
          paddingBottom: 30,
          display: 'table-cell',
        }}
      />
    </div>
  </div>
)

const Column = ({ children, width, borderLeft, style = {} }) => (
  <div
    style={{
      width,
      display: width && 'table-cell',
      borderLeft,
      borderTop: `1px solid ${colors.middleGrey}`,
      borderRight: `1px solid ${colors.middleGrey}`,
      borderBottom: `1px solid ${colors.middleGrey}`,
      verticalAlign: 'top',
      padding: 10,
      height: 'inherit',
      minHeight: 240,
      ...style,
    }}
  >
    {children}
  </div>
)

const Vote = ({ data, person, small }) =>
  small ? (
    <div>
      <Column width={undefined} style={{ borderBottom: null }}>
        <VoteMiddleColumn data={data} />
      </Column>
      <div style={{ display: 'table', marginBottom: 15, width: '100%' }}>
        <div style={{ display: 'table-row', height: 1 }}>
          <Column
            width={'30%'}
            borderLeft={`1px solid ${data.positivity === 1
              ? colors.green
              : colors.red}`}
            style={{ position: 'relative', padding: 0 }}
          >
            <div
              style={{
                display: 'inline-block',
                position: 'absolute',
                paddingLeft: 70,
                width: '100%',
                height: '100%',
                verticalAlign: 'middle',
              }}
            >
              <div
                style={{
                  display: 'inline-block',
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  paddingRight: 10,
                }}
              >
                {data.restName}
              </div>
            </div>
            <div style={{ display: 'inline-block', padding: 10 }}>
              <Paragraph
                fullness={data.weight}
                color={positivityToColor(data.positivity)}
              />
              <div style={{ display: 'table-cell', verticalAlign: 'bottom' }}>
                <div
                  style={{
                    fontSize: '1.5em',
                    lineHeight: '1em',
                    textAlign: 'center',
                  }}
                >
                  {data.weight.toFixed(2)}
                </div>
                <div style={{ textAlign: 'center', marginTop: -3 }}>váha</div>
              </div>
            </div>
          </Column>
          <Column
            width={'40%'}
            style={{
              textAlign: 'center',
              verticalAlign: 'middle',
              paddingTop: 30,
            }}
          >
            <VoteHead data={data} person={person} />
            <VoteThumb
              data={data}
              person={person}
              style={{ display: 'inline-block' }}
            />
          </Column>

          <Column
            width={'30%'}
            style={{ textAlign: 'center', verticalAlign: 'middle' }}
          >
            <Result data={data} type={person.type} />
          </Column>
        </div>
      </div>
    </div>
  ) : (
    <div style={{ display: 'table', minHeight: 240, marginBottom: 15 }}>
      <div style={{ display: 'table-row', height: 1 }}>
        <Column
          width={110}
          borderLeft={`1px solid ${data.positivity === 1
            ? colors.green
            : colors.red}`}
        >
          <VoteLeftColumn data={data} />
        </Column>
        <Column width={590} height={500}>
          <VoteMiddleColumn data={data} />
          {/* data={{ ...data, standpoint: 'Senátní verze návrhu zákona je nefunkční a nezachovává sankci neplatnosti' }} /> */}
        </Column>
        <Column width={250}>
          <VoteRightColumn data={data} person={person} />
        </Column>
      </div>
    </div>
  )

const NoVoteYet = ({ person }) => (
  <div
    style={{
      fontSize: '1.2em',
      textAlign: 'center',
      color: colors.darkGrey,
    }}
  >
    {(() => {
      if (person.type === 'MOP') {
        if (person.gender === 'M') return 'Poslanec'
        return 'Poslankyně'
      }
      if (person.gender === 'M') return 'Senátor'
      return 'Senátorka'
    })()}{' '}
    neměl{person.gender === 'M' ? '' : 'a'} mandát během žádného hlasování o
    tomto RESTu
  </div>
)

const byDate = (a, b) => {
  const map = date =>
    date
      .split('.')
      .reverse()
      .map(s => padStart(s, 4, '0'))
      .join('')
  if (map(a.date) < map(b.date)) return 1
  return -1
}

const NoKeyVotes = () => (
  <div
    style={{
      fontSize: '1.2em',
      textAlign: 'center',
      color: colors.darkGrey,
    }}
  >
    Zatím neproběhla žádná klíčová hlasování.
  </div>
)

class PoliticianVotes extends Component {
  constructor() {
    super()
    this.state = { importantOnly: true }
    this.handleImportantOnly = this.handleImportantOnly.bind(this)
  }
  handleImportantOnly(checked) {
    this.setState({ importantOnly: checked })
  }
  render() {
    const { votes, person, small } = this.props
    const filteredVotes = votes
      .sort(byDate)
      .filter(vote => vote.weight > 0.3 || !this.state.importantOnly)
    return (
      <div>
        <div style={{ textAlign: 'center' }}>
          <h3>Hlasování podrobně</h3>
        </div>
        <Checkbox
          id="important-votes-only"
          checked={this.state.importantOnly}
          onChange={this.handleImportantOnly}
        >
          Pouze klíčová hlasování
        </Checkbox>
        <div>
          {votes.length <= 0 ? (
            <NoVoteYet person={person} />
          ) : filteredVotes.length > 0 ? (
            filteredVotes.map(vote => (
              <Vote small={small} key={vote.i} data={vote} person={person} />
            ))
          ) : (
            <NoKeyVotes />
          )}
        </div>
      </div>
    )
  }
}
export default PoliticianVotes



// WEBPACK FOOTER //
// ./components/PoliticianDetail/PoliticianVotes.js